'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  tags: null,
  filters: null,
  functions: null,
  expTests: null
});